module.exports = __webpack_public_path__ + "static/media/add patient.7d423ae2.svg";